module.exports = __webpack_public_path__ + "0ef92a68504960dbf0c38ec2796bd079.png";